/** Generated at build from package.json */
export const version = "0.0.39";
